module.exports = __webpack_public_path__ + "img/newcompany.8d464ac4.png";